<div id="loadingModal" class="h-modal h-modal--small" aria-hidden="false">
  <div class="h-modal__bg"></div>
  <div class="h-modal__position">
    <div class="h-modal__dialog" role="dialog" tabindex="0">
      <div class="h-modal__content">
        <!-- modal body -->
        <div class="h-modal__body">
          <div class="h-gr" style="justify-content: center;">
            <div class="h-cl">
              <p class="loader-text">
                מעבירים אותך...
              </p>
              <br>
              <div class="is-visible loader">
                <svg class="loader__svg" focusable="false" preserveAspectRatio="xMidYMid meet" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                  <circle class="loader__path" cx="50%" cy="50%" r="30"></circle>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>